import { render, staticRenderFns } from "./CardTicket.vue?vue&type=template&id=5670014d&scoped=true&"
import script from "./CardTicket.vue?vue&type=script&lang=js&"
export * from "./CardTicket.vue?vue&type=script&lang=js&"
import style0 from "./CardTicket.vue?vue&type=style&index=0&id=5670014d&prod&lang=sass&scoped=true&"
import style1 from "./CardTicket.vue?vue&type=style&index=1&id=5670014d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670014d",
  null
  
)

export default component.exports